<div class="bg-white rounded-[10px] flex flex-col overflow-hidden">
  @if (isOffline()) {
  <p class="fg-orange-1 text-[14px] text-center p-3 m-0 bg-orange-3">
    {{ 'admin_settings.order_modes.errors.offline_message' | translate }}
  </p>
  }
  <div class="flex items-center justify-between px-5 py-[15px]">
    <span class="fg-noir-2 text-[14px] font-medium">
      {{ 'admin_settings.order_modes.meal_plan_label' | translate }}
    </span>
    <button type="button" [disabled]="isOffline()" (click)="toggleMealPlan()"
      class="relative h-[28px] w-[56px] rounded-full flex items-center transition-colors cursor-pointer px-[3px] disabled:opacity-50 disabled:cursor-not-allowed"
      [class.bg-vert-1]="mealPlanEnabled()" [class.bg-gris-3]="!mealPlanEnabled()"
      [class.justify-end]="mealPlanEnabled()" [class.justify-start]="!mealPlanEnabled()">
      <span class="size-[22px] rounded-full bg-white shrink-0 shadow"></span>
    </button>
  </div>
  <div class="flex items-center justify-between px-5 py-[15px] border-t border-gris-3">
    <span class="fg-noir-2 text-[14px] font-medium">
      {{ 'admin_settings.order_modes.by_course_label' | translate }}
    </span>
    <button type="button" [disabled]="isOffline()" (click)="toggleByCourse()"
      class="relative h-[28px] w-[56px] rounded-full flex items-center transition-colors cursor-pointer px-[3px] disabled:opacity-50 disabled:cursor-not-allowed"
      [class.bg-vert-1]="byCourseEnabled()" [class.bg-gris-3]="!byCourseEnabled()"
      [class.justify-end]="byCourseEnabled()" [class.justify-start]="!byCourseEnabled()">
      <span class="size-[22px] rounded-full bg-white shrink-0 shadow"></span>
    </button>
  </div>
</div>
